import { useMemo } from 'react';
import type { AdminEmailTemplateRow } from '../../../domain/superadmin/types';
import { buildSampleVars } from '../../../domain/superadmin/emailTest';
import { interpolateTemplate } from '../../../domain/superadmin/communications';
import { Button } from '../../../components/ui';
import Modal from '../../../components/ui/Modal';
import { EmailTemplatePreviewFrame } from './EmailTemplatePreviewFrame';

interface EmailTemplatePreviewModalProps {
    template: AdminEmailTemplateRow | null;
    isOpen: boolean;
    onClose: () => void;
    onSendTest: (template: AdminEmailTemplateRow) => void;
}

export function EmailTemplatePreviewModal({
    template,
    isOpen,
    onClose,
    onSendTest,
}: EmailTemplatePreviewModalProps) {
    // Production app URL — matches Edge APP_URL / real customer messages (not localhost).
    const sampleVars = useMemo(() => buildSampleVars(), []);

    const interpolatedSubject = useMemo(() => {
        if (!template) return '';
        return interpolateTemplate(template.subject, sampleVars);
    }, [template, sampleVars]);

    const interpolatedBody = useMemo(() => {
        if (!template) return '';
        return interpolateTemplate(template.bodyHtml, sampleVars);
    }, [template, sampleVars]);

    if (!template) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="2xl">
            <Modal.Header onClose={onClose}>{template.name}</Modal.Header>
            <Modal.Body>
                <p className="text-sm text-secondary">
                    Assunto: <span className="text-default">{interpolatedSubject}</span>
                </p>
                <EmailTemplatePreviewFrame bodyHtml={interpolatedBody} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Fechar
                </Button>
                <Button onClick={() => onSendTest(template)}>Enviar teste</Button>
            </Modal.Footer>
        </Modal>
    );
}
